import { useProposalRecordHeader } from './useProposalRecordHeader';
/**
 * The pursuit a proposal was spawned from (GetProposalRecordHeader.pursuit).
 * Undefined while loading, when direct, when the pursuit is unreadable, or when
 * it has no name — callers degrade to the unlinked shell and never render an
 * empty crumb.
 */ export function useProposalPursuit(projectId) {
    const pursuit = useProposalRecordHeader(projectId).data?.pursuit;
    const name = pursuit?.name.trim();
    if (!pursuit || !pursuit.captureProjectId || !name) return undefined;
    return {
        id: pursuit.captureProjectId,
        name,
        href: pursuit.href
    };
}
